<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2l"><a id="ch02"></a><a id="page_20"><span class="smallcaps">CHAPTER TWO</span></a></h2><a id="page_20">
<h2 class="h2titlel"><span class="txit">Arlene</span></h2>
<p class="noindent"><span class="stickup">R</span>icky never exactly came home, not like she thought he would, but the truck did. Only not like she thought it would. It had been rolled a few times; all in all, it looked worse than she felt. Only it ran. Well, it idled. It’s one thing to start up and run, quite another to actually get somewhere.</p>
<p class="indent">Much as she resented that Ford extra cab for imitating her own current condition, she could have forgiven it that. Potentially, she could. It was the way it kept her awake at night. Especially now, when she’d taken a second job, at the Laser Lounge, to keep up the payments. And since it was the truck’s fault that she didn’t get to bed until three, it at least could have let her sleep. Surely that would not have been asking too much.</p>
</a><p class="indent"><a id="page_20">Yet there she was again at the window, double-checking the way moonlight slid off the vehicle’s </a><a id="page_21">spooky shape. The way its silvery reflection broke where the paint broke. Only Ricky could mess up a truck that bad and walk away. At least, it would stand to reason that he had walked away, seeing that the truck was found and Ricky was not.</a></p><a id="page_21">
<p class="indent"><span class="txit">Dragged off by coyotes? Stop, Arlene, just get ahold of yourself.</span></p>
<p class="indent">Unless, of course, he limped away, not sauntered off, maybe dragged himself to a hospital, maybe got out okay, maybe died, far from anything to tie him to a Ford extra cab, far from any ties to hometown news.</p>
<p class="indent">So there could be a grave somewhere, but how would Arlene know? And even if she did, she could not know which one or where. Even if she bought flowers for Ricky out of her tip money, she and her boy, Trevor, would never know where to put them.</p>
<p class="indent"><span class="txit">Flowers can be a bad thing, a bad thought, if you don’t even know where to lay them down. Just stop, Arlene. Just go back to bed.</span></p>
<p class="indent">And she did, but she fell victim to a dream in which Ricky had been living just outside the town for months and months and never bothered to contact her with his whereabouts.</p>
<p class="indent">Which made her cross to the window again to blame the darn truck for keeping her awake.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02.vue?a3669bfe